<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">receipt_long</mat-icon>
        Lista de Transacciones
        <span *ngIf="transacciones.length"
          class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ transacciones.length }} registros
        </span>
      </h1>
      <span *ngIf="transacciones.length"
        class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
        {{ transacciones.length }} registros
      </span>
    </div>
  </div>

  <!-- Filtros - Card centrada y compacta -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">

      <div class="text-center mb-6">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Búsqueda
        </h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Nombre, email, ID...">
        </mat-form-field>

        <div class="flex items-center justify-center gap-4">
          <div class="flex items-center gap-2 text-sm text-gray-600">
            <span class="font-semibold text-aguacate-green">{{ seleccionados }}</span> seleccionadas
          </div>
          <button type="button" [disabled]="seleccionados === 0" (click)="limpiarSeleccion()"
            [style.opacity]="seleccionados === 0 ? '0.5' : '1'"
            [style.cursor]="seleccionados === 0 ? 'not-allowed' : 'pointer'"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
            onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">clear_all</mat-icon>
            Limpiar selección
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Tabla de transacciones (solo desktop) -->
  <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white" *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

      <!-- Columna Selección -->
      <ng-container matColumnDef="seleccion">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold" style="width: 50px;">
          Sel.
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <mat-checkbox (change)="change()" [disabled]="row.estado !== 'POR_PROCESAR'" [(ngModel)]="row.seleccionado"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Columna ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          ID
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs font-mono">
          {{ row.id }}
        </td>
      </ng-container>

      <!-- Columna Canal -->
      <ng-container matColumnDef="canal">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Canal
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
            [class]="row.tipoTransaccion === 'AC' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'">
            {{ row.tipoTransaccion === 'AC' ? 'Detal' : 'Mayorista' }}
          </span>
        </td>
      </ng-container>

      <!-- Columna Fecha Creación -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Fecha Creación
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <div class="text-xs font-medium">{{ getDateOnly(row.createdAt) }}</div>
          <div class="text-xs font-medium">{{ getTimeOnly(row.createdAt) }}</div>
        </td>
      </ng-container>

      <!-- Columna Fecha Fondeo Wallet -->
      <ng-container matColumnDef="fechaFondeoWallet">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Fecha Fondeo
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 hide-on-mobile">
          <div class="text-xs font-medium">{{ getDateOnly(row.fechaFondeoWallet) }}</div>
          <div class="text-xs font-medium">{{ getTimeOnly(row.fechaFondeoWallet) }}</div>
        </td>
      </ng-container>

      <!-- Columna Fecha Término -->
      <ng-container matColumnDef="fechaTermino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Fecha Término
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 hide-on-mobile">
          <div class="text-xs font-medium">{{ getDateOnly(row.fechaTermino) }}</div>
          <div class="text-xs font-medium">{{ getTimeOnly(row.fechaTermino) }}</div>
        </td>
      </ng-container>

      <!-- Columna Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold hide-on-mobile">
          Email
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2 text-xs hide-on-mobile" style="word-break: break-all;">
          {{ row.usuario.email || '' }}
        </td>
      </ng-container>

      <!-- Columna Nombre Usuario -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">
          Usuario
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2">
          <div class="font-medium text-sm">{{ row.usuario.nombre }} {{ row.usuario.apellidos }}</div>
          <div class="text-xs font-bold font-mono">ID: {{ row.userId }}</div>
          <div class="text-xs text-blue-600">{{ row.usuario.email }}</div>
        </td>
      </ng-container>

      <!-- Columna Beneficiario -->
      <ng-container matColumnDef="cuentaBeneficiarioId">
        <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">
          Beneficiario
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2">
          <div class="font-medium text-xs">{{ row.cuentaBeneficiario.nombre }} {{ row.cuentaBeneficiario.apellidos }}</div>
          <div class="text-xs text-blue-600 font-semibold">{{ row.cuentaBeneficiario.numeroCuenta }}</div>
        </td>
      </ng-container>

      <!-- Columna Tipo Cuenta Beneficiario -->
      <ng-container matColumnDef="tipoCuentaBeneficiarioId">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Tipo Cuenta
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          {{ row.cuentaBeneficiario.movilPay === 1 ? 'MovilPay' : 'Cuenta bancaria' }}
        </td>
      </ng-container>

      <!-- Columna Ruta -->
      <ng-container matColumnDef="ruta">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Ruta
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          {{ row.paisOrigen }} - {{ row.paisDestino }}
        </td>
      </ng-container>

      <!-- Columna Banco Destino -->
      <ng-container matColumnDef="bancoDestino">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold hide-on-mobile">
          Banco Destino
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs hide-on-mobile">
          {{ row.cuentaBeneficiario.banco?.nombre || 'Sin banco' }}
        </td>
      </ng-container>

      <!-- Columna Monto Origen -->
      <ng-container matColumnDef="totalMonedaOrigen">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">
          Monto Origen
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaOrigen | currency:'$' }}
        </td>
      </ng-container>

      <!-- Columna Monto Destino -->
      <ng-container matColumnDef="totalMonedaDestino">
        <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">
          Monto Destino
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2 text-xs font-bold text-green-600">
          {{ row.totalMonedaDestino | currency:'$' }}
        </td>
      </ng-container>

      <!-- Columna Estado -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Estado
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <span class="px-2 py-0.5 inline-flex leading-5 font-bold rounded-full whitespace-nowrap"
            style="font-size: 0.65rem; text-transform: capitalize;"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estado.replaceAll('_', ' ').toLowerCase() }}
          </span>
        </td>
      </ng-container>

      <!-- Columna Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">
          Acciones
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <div class="flex gap-1 justify-center flex-wrap">
            <button title="Asignar" (click)="openAssignDialog(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">assignment_add</mat-icon>
            </button>
            <button *ngIf="row.voucher" title="Ver comprobante" (click)="openImageDialog(row.voucher)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
            </button>
            <!-- Rechazar solo en POR_PROCESAR: es el único estado desde el que la lambda acepta el rechazo (H3/H4, 25/10/2026) -->
            <button *ngIf="row.voucher && row.estado === 'POR_PROCESAR'" title="Rechazar" (click)="rejectTransaction(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">cancel</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-100 transition-colors"></tr>
    </table>
  </div>

  <!-- ═══ Mobile / Tablet Cards (Acordeón) ═══ -->
  <div class="lg:hidden">
    <div *ngIf="!dataSource || transacciones.length === 0"
      style="text-align: center; padding: 40px 20px;">
      <mat-icon style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px;">receipt_long</mat-icon>
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">No se encontraron transacciones</p>
    </div>

    <div *ngFor="let row of transacciones"
      style="border: 1px solid #e5e7eb; border-radius: 10px; overflow: hidden; margin-bottom: 8px;"
      [style.border-color]="expandedCardId === row.id ? '#1C593D' : '#e5e7eb'">

      <!-- Card header (siempre visible, clickeable) -->
      <div (click)="toggleCard(row.id)"
        style="display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; cursor: pointer; user-select: none;"
        [style.background]="expandedCardId === row.id ? '#f0fdf4' : '#f9fafb'">

        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap; flex: 1; min-width: 0;">
          <mat-checkbox (change)="change()" [disabled]="row.estado !== 'POR_PROCESAR'" [(ngModel)]="row.seleccionado"
            (click)="$event.stopPropagation()"></mat-checkbox>
          <span style="background: #dcfce7; color: #1e5a3f; font-size: 0.7rem; padding: 2px 7px; border-radius: 10px; font-weight: 600;">
            #{{ row.id }}
          </span>
          <span style="font-size: 0.6rem; padding: 2px 8px; border-radius: 10px; font-weight: 700; white-space: nowrap; text-transform: capitalize;"
            [style.background]="getStatusBg(row)"
            [style.color]="getStatusColor(row)">
            {{ row.estado.replaceAll('_', ' ').toLowerCase() }}
          </span>
          <span class="px-2 py-0.5 rounded-full" style="font-size: 0.65rem; font-weight: 600;"
            [class]="row.tipoTransaccion === 'AC' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'">
            {{ row.tipoTransaccion === 'AC' ? 'Detal' : 'Mayorista' }}
          </span>
          <span style="font-size: 0.7rem; color: #374151; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ row.usuario.nombre }} {{ row.usuario.apellidos }}
          </span>
          <span style="font-size: 0.7rem; color: #1e5a3f; font-weight: 700; white-space: nowrap;">
            {{ row.totalMonedaOrigen | currency:'$' }}
          </span>
        </div>

        <mat-icon style="color: #6b7280; font-size: 20px; width: 20px; height: 20px; transition: transform 0.2s ease; flex-shrink: 0; margin-left: 4px;"
          [style.transform]="expandedCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body (colapsable) -->
      <div *ngIf="expandedCardId === row.id" class="card-body-expanded">
        <div style="padding: 12px 16px; background: white;">
          <div class="grid grid-cols-2 gap-x-12 gap-y-1">

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.usuario.nombre }} {{ row.usuario.apellidos }}
              </span>
              <span style="color: #111827; font-weight: 700; font-size: 0.8rem; font-family: monospace; margin-left: 6px;">ID: {{ row.userId }}</span>
              <div style="color: #2563eb; font-size: 0.8rem; word-break: break-all;">{{ row.usuario.email }}</div>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Canal</span>
              <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
                [class]="row.tipoTransaccion === 'AC' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'">
                {{ row.tipoTransaccion === 'AC' ? 'Detal' : 'Mayorista' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Ruta</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.paisOrigen }} → {{ row.paisDestino }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha creación</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.8rem;">{{ getDateFormatted(row.createdAt) }}</span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha fondeo</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.8rem;">{{ getDateFormatted(row.fechaFondeoWallet) }}</span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto origen</span>
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">{{ row.totalMonedaOrigen | currency:'$' }}</span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto destino</span>
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem;">{{ row.totalMonedaDestino | currency:'$' }}</span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco destino</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.cuentaBeneficiario.banco?.nombre || 'Sin banco' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo cuenta</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.cuentaBeneficiario.movilPay === 1 ? 'MovilPay' : 'Cuenta bancaria' }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6; grid-column: 1 / -1;">
              <span style="color: #6b7280; font-size: 0.75rem; display: block;">Beneficiario</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">
                {{ row.cuentaBeneficiario.nombre }} {{ row.cuentaBeneficiario.apellidos }}
                <span *ngIf="row.cuentaBeneficiario.numeroCuenta" style="color: #2563eb; font-weight: 600;">
                  | {{ row.cuentaBeneficiario.numeroCuenta }}
                </span>
              </span>
            </div>

          </div>
        </div>

        <!-- Botones de acción -->
        <div style="display: flex; gap: 8px; padding: 10px 16px; background: #f9fafb; border-top: 1px solid #f3f4f6; flex-wrap: wrap;">
          <button (click)="openAssignDialog(row)"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">assignment_add</mat-icon>
            Asignar
          </button>
          <button *ngIf="row.voucher" (click)="openImageDialog(row.voucher)"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #2563eb; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon>
            Comprobante
          </button>
          <!-- Rechazar solo en POR_PROCESAR (mismo criterio que la lambda, H3/H4 25/10/2026) -->
          <button *ngIf="row.voucher && row.estado === 'POR_PROCESAR'" (click)="rejectTransaction(row)"
            style="display: flex; align-items: center; gap: 6px; padding: 8px 14px; background: #ef4444; color: white; border: none; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer; flex: 1; justify-content: center;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">cancel</mat-icon>
            Rechazar
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
